
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/amount-of-deposit-and-bidding-limit",
      function () {
        return require("private-next-pages/content/amount-of-deposit-and-bidding-limit.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/amount-of-deposit-and-bidding-limit"])
      });
    }
  